import React from 'react';
import BookstoreLayout from '../bookstore-layout';
import Layout from '../../layout';

const TrainingMaterialsLayout: React.FC = ({ children }) => (
  <Layout title="Training Materials">
    <BookstoreLayout
      title="Training Materials"
      subtitle="Welcome to the Training Materials page of this website. The training items listed on these pages are original classroom materials used by Volvo Training instructors. The material is either printed or VHS tape, dependent upon selection."
      breadcrumb={{ url: '/training', text: 'Back' }}
      hero=""
    >
      {children}
    </BookstoreLayout>
  </Layout>
);

export default TrainingMaterialsLayout;
